// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y0Rf","tabsBox":"styles_tabsBox__21f2f","createButton":"styles_createButton__2cTtZ"};